import { AppRouteProps } from "@harea/component";
import React from "react";
import { HomeRoutes } from "./dashboard/HomeRoutes";
import { AuthorityRoutes } from "./authority/AuthorityRoutes";
import { RoleRoutes } from "./role/RoleRoutes";
import { PermissionRoutes } from "./permission/PermissionRoutes";
import { TranslationRoutes } from "@harea/translation";
import { CotisationRoutes } from "@harea/payroll";
import { AuthRoutes } from "@harea/login";

import { WizardRoutes } from "@harea/wizard";
import { WizardNodeRoutes } from "@harea/wizard-node";
import { Outlet } from "react-router-dom";
// import { DocumentRoutes } from "@harea/document"
import { StaticPageRoutes } from "@harea/static-page";
import {
  UserDetailsRoutes,
  TaxBracketsRoutes,
  OvertimeRoutes,
} from "@harea/user-management";
import { PayingRoutes } from "@harea/billing";

const AuthLayout = React.lazy(() => import("layout/AuthLayout"));
const MainLayout = React.lazy(() => import("layout/MainLayout"));

export const BoRoutes: Array<AppRouteProps> = [
  {
    path: ":lang",
    title: `Bo.title`,
    element: <Outlet />,
    children: [
      {
        path: "",
        element: <MainLayout />,
        children: [...HomeRoutes],
      },
      {
        path: "admin",
        element: <MainLayout />,
        children: [
          ...HomeRoutes,
          ...AuthorityRoutes,
          ...RoleRoutes,
          ...PermissionRoutes,
          ...TranslationRoutes,
          ...CotisationRoutes,
          ...WizardRoutes,
          ...WizardNodeRoutes,
          // ...DocumentRoutes,
          ...StaticPageRoutes,
          ...UserDetailsRoutes,
          ...TaxBracketsRoutes,
          ...PayingRoutes,
          ...OvertimeRoutes,
        ],
      },
      {
        path: "",
        element: <AuthLayout />,
        children: [...AuthRoutes],
      },
    ],
  },
];
